import { Injectable } from '@jack-henry/frontend-utils/di';
import { ApiClient as ChannelApiClient } from '@treasury/api/channel';
import { LoggingService } from '@treasury/core/logging';
import { WindowService } from '@treasury/utils';
import { StatusService } from './status.service';

@Injectable()
export class ChannelStatusService extends StatusService {
    constructor(
        window: WindowService,
        logger: LoggingService,
        private readonly channelApi: ChannelApiClient
    ) {
        super(window, logger);
    }

    protected async getApiStatus() {
        const config = {
            skipDatabaseConnectivity: true,
            skipRedisConnectivity: false,
            skipPackageInformation: true,
        };

        const response = await this.channelApi.healthGet(config);
        return {
            success: response.data.success ?? false,
        };
    }
}
